import { clsx } from 'clsx'
import { type FC, type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
  Link,
} from 'base-ui'

import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../../../global-config'
import {
  urlResolverGetMediServiceRxLandingPageFirstQuestionPartnerLink,
  urlResolverGetMediServiceRxLandingPageSecondQuestionPartnerLink,
} from '../../../../../url-handling'

import styles from './Faq.module.css'

type QaSectionData = {
  answer: JSX.Element
  key: string
  question: JSX.Element
}

const faqQuestions = (config: PublicGlobalConfig): QaSectionData[] => [
  {
    answer: (
      <FormattedMessage
        id="chrx.faq.a1.new"
        values={{
          link: (text) => (
            <Link
              href={urlResolverGetMediServiceRxLandingPageFirstQuestionPartnerLink(
                config,
              )}
              rel="noreferrer"
              target="_blank"
            >
              {text}
            </Link>
          ),
        }}
      />
    ),
    key: 'rx.ch.faq.question.1',
    question: <FormattedMessage id="rx.ch.faq.question.1" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage
          id="rx.ch.faq.answer.2.new"
          values={{
            link: (text) => (
              <Link
                href={urlResolverGetMediServiceRxLandingPageSecondQuestionPartnerLink(
                  config,
                )}
                rel="noreferrer"
                target="_blank"
              >
                {text}
              </Link>
            ),
          }}
        />
      </p>
    ),
    key: 'rx.ch.faq.question.2',
    question: <FormattedMessage id="rx.ch.faq.question.2" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.ch.faq.answer.3" />
      </p>
    ),
    key: 'rx.ch.faq.question.3',
    question: <FormattedMessage id="rx.ch.faq.question.3" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.4" />,
    key: 'rx.ch.faq.question.4',
    question: <FormattedMessage id="rx.ch.faq.question.4" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.11" />,
    key: 'rx.ch.faq.question.11',
    question: <FormattedMessage id="rx.ch.faq.question.11" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.10" />,
    key: 'rx.ch.faq.question.10',
    question: <FormattedMessage id="rx.ch.faq.question.10" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.9" />,
    key: 'rx.ch.faq.question.9',
    question: <FormattedMessage id="rx.ch.faq.question.9" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.5" />,
    key: 'rx.ch.faq.question.5',
    question: <FormattedMessage id="rx.ch.faq.question.5" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.8" />,
    key: 'rx.ch.faq.question.8',
    question: <FormattedMessage id="rx.ch.faq.question.8" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.ch.faq.answer.6.new" />
      </p>
    ),
    key: 'rx.ch.faq.question.6',
    question: <FormattedMessage id="rx.ch.faq.question.6" />,
  },
  {
    answer: <FormattedMessage id="rx.ch.faq.answer.7" />,
    key: 'rx.ch.faq.question.7',
    question: <FormattedMessage id="rx.ch.faq.question.7" />,
  },
]

export const RxLpChFaq: FC = () => {
  const config = useGlobalConfigContext()
  const faqQuestionsWithLinks = faqQuestions(config)

  return (
    <div className="tablet:flex tablet:justify-center">
      <div
        className={clsx(
          styles.faq,
          'container px-4 py-6 tablet:px-0 tablet:py-9',
        )}
      >
        <span className={styles['faq-title']}>
          <FormattedMessage id="rx.ch.faq.title" />
        </span>
        <AccordionStack>
          {faqQuestionsWithLinks.map(({ answer, key, question }) => (
            <Accordion key={key}>
              <AccordionSummary>{question}</AccordionSummary>
              <AccordionDetails className="prose">{answer}</AccordionDetails>
            </Accordion>
          ))}
        </AccordionStack>
      </div>
    </div>
  )
}
